/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nfp_Feat_4_DescInputs */

const en_nfp_feat_4_desc = /** @type {(inputs: Nfp_Feat_4_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Approved Non-Profits receive a global Verified Emerald Badge, signaling immediate trust and security to your supporters.`)
};

const es_nfp_feat_4_desc = /** @type {(inputs: Nfp_Feat_4_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Las ONGs aprobadas reciben una insignia global que indica confianza y seguridad.`)
};

const fr_nfp_feat_4_desc = /** @type {(inputs: Nfp_Feat_4_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les associations à but non lucratif approuvées reçoivent un badge d'Émeraude Vérifié global, signalant une confiance et une sécurité immédiates à vos supporters.`)
};

const de_nfp_feat_4_desc = /** @type {(inputs: Nfp_Feat_4_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genehmigte NGOs erhalten ein globales, verifiziertes Smaragd-Abzeichen.`)
};

const id_nfp_feat_4_desc = /** @type {(inputs: Nfp_Feat_4_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non-Profit yang Disetujui menerima Lencana Zamrud Terverifikasi global, yang menandakan kepercayaan dan keamanan langsung kepada pendukung Anda.`)
};

/** @type {(inputs: Nfp_Feat_4_DescInputs) => LocalizedString} */
const ja_nfp_feat_4_desc = en_nfp_feat_4_desc;

/** @type {(inputs: Nfp_Feat_4_DescInputs) => LocalizedString} */
const zh_nfp_feat_4_desc = en_nfp_feat_4_desc;

/** @type {(inputs: Nfp_Feat_4_DescInputs) => LocalizedString} */
const ar_nfp_feat_4_desc = en_nfp_feat_4_desc;

/** @type {(inputs: Nfp_Feat_4_DescInputs) => LocalizedString} */
const it_nfp_feat_4_desc = en_nfp_feat_4_desc;

/** @type {(inputs: Nfp_Feat_4_DescInputs) => LocalizedString} */
const ru_nfp_feat_4_desc = en_nfp_feat_4_desc;

/** @type {(inputs: Nfp_Feat_4_DescInputs) => LocalizedString} */
const pt_nfp_feat_4_desc = en_nfp_feat_4_desc;

/** @type {(inputs: Nfp_Feat_4_DescInputs) => LocalizedString} */
const ko_nfp_feat_4_desc = en_nfp_feat_4_desc;

/**
* | output |
* | --- |
* | "Approved Non-Profits receive a global Verified Emerald Badge, signaling immediate trust and security to your supporters." |
*
* @param {Nfp_Feat_4_DescInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const nfp_feat_4_desc = /** @type {((inputs?: Nfp_Feat_4_DescInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nfp_Feat_4_DescInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nfp_feat_4_desc(inputs)
	if (locale === "es") return es_nfp_feat_4_desc(inputs)
	if (locale === "fr") return fr_nfp_feat_4_desc(inputs)
	if (locale === "de") return de_nfp_feat_4_desc(inputs)
	if (locale === "ja") return ja_nfp_feat_4_desc(inputs)
	if (locale === "zh") return zh_nfp_feat_4_desc(inputs)
	if (locale === "ar") return ar_nfp_feat_4_desc(inputs)
	if (locale === "id") return id_nfp_feat_4_desc(inputs)
	if (locale === "it") return it_nfp_feat_4_desc(inputs)
	if (locale === "ru") return ru_nfp_feat_4_desc(inputs)
	if (locale === "pt") return pt_nfp_feat_4_desc(inputs)
	return ko_nfp_feat_4_desc(inputs)
});